/**
 * Ryan O'Dowd
 * 2024-10-30
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const EmptyScreenWrapper = (props: EmptyScreenWrapperProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View// @TODO: should this be a scrollview?
      style={[
        styles.container,
        props.avoidKeyboard && styles.avoidKeyboard,
        props.extraStyle, // @TODO: allow this to be an array?
      ]}
    >
      {props.children}
    </View>
  );
};

class EmptyScreenWrapperProps {
  children: React.ReactNode;

  extraStyle?: any;
  avoidKeyboard?: boolean;
};

export default EmptyScreenWrapper;
